import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { getOrganizationDisplayName } from '../../shell/navigation/organizationDisplayName';
import { getOrganizationEntitlementsCacheIfFresh } from '../../shell/feature-flags/planEntitlementsService';
import type { SaleReceiptBranding } from './buildSaleReceiptPayload';

function normOrgLabel(value: string): string {
  return value.trim().toLocaleLowerCase('es-AR');
}

/**
 * Nombre comercial (org) + sucursal en el ticket.
 * Una sola línea si es la misma etiqueta o sucursal única con nombre distinto al comercial solo cuando hace falta (multi-sucursal o nombres distintos).
 */
export function resolveSaleReceiptBranding(branchId: string): SaleReceiptBranding {
  const state = useSessionStore.getState();
  const branch = state.branches.find((b) => b.id === branchId);
  const branchNameRaw = branch?.name?.trim() || 'Sucursal';
  const entitlements = getOrganizationEntitlementsCacheIfFresh();
  const orgName = getOrganizationDisplayName(entitlements ?? null);
  const multiBranch = state.branches.length > 1;

  if (!orgName) {
    return { branchName: branchNameRaw, organizationName: null };
  }

  const sameLabel = normOrgLabel(branchNameRaw) === normOrgLabel(orgName);
  if (!multiBranch && sameLabel) {
    return { branchName: orgName, organizationName: null };
  }
  if (sameLabel) {
    return { branchName: orgName, organizationName: null };
  }

  return { branchName: branchNameRaw, organizationName: orgName };
}
